<lb-two-column-page-layout>
	<ng-container two-column-page-layout-left-content>
		@if (!lessonList.loaded()) {
			<lb-loader></lb-loader>
		} @else {
			<div class="lesson-view">
				<div class="content-header">
					<div class="upcoming-previous">
						<md-button-group [value]="lessonList.displayType()" (change)="updateDisplayType($event)">
							<md-button-toggle value="Upcoming" [disabled]="lessonList.upcomingCount() === 0">
								Upcoming
								<md-tag [type]="lessonList.upcomingCount() === 0 ? 'disabled' : 'default'">{{ lessonList.upcomingCount() }}</md-tag>
							</md-button-toggle>
							<md-button-toggle value="Previous" [disabled]="lessonList.pastCount() === 0">
								Prior
								<md-tag [type]="lessonList.pastCount() === 0 ? 'disabled' : 'default'">{{ lessonList.pastCount() }}</md-tag>
							</md-button-toggle>
						</md-button-group>
					</div>

					<div class="header-actions">
						<lb-search-bar [value]="lessonList.searchText()" (changed)="updateSearchValue($event)" />
						<a routerLink="/calendar" md-button>View Calendar</a>
					</div>
				</div>

				<div class="main-content">
					<!-- Loader sits inside the list so the tabs, search and paginator stay mounted across
					     page changes — remounting the paginator is what used to reset its page size. -->
					<div class="lesson-list">
						@if (lessonList.loading()) {
							<lb-loader></lb-loader>
						} @else {
							@for (lesson of lessonList.filteredItems(); track lesson.lessonID) {
								@if (usesV2(lesson)) {
									<lrnr-lesson-card [lesson]="lesson" (dataChanged)="reload()"></lrnr-lesson-card>
								} @else {
									<lb-readonly-lesson-card [lesson]="lesson" [isPopup]="false" (dataChanged)="reload()"> </lb-readonly-lesson-card>
								}
							} @empty {
								No Lessons to display
							}
						}
					</div>

					@if (lessonList.showPaginator()) {
						<div class="pagination-row">
							<lb-paginator
								[currentPage]="lessonList.page()"
								[itemsPerPage]="lessonList.pageSize()"
								[totalItems]="lessonList.totalCount()"
								[itemsPerPageOptions]="lessonList.pageSizeOptions()"
								[enableAutoScroll]="false"
								(pageChange)="onPageChange($event)"
								(pageLengthChange)="onPageLengthChange($event)"
							>
							</lb-paginator>
						</div>
					}
				</div>
			</div>
		}
	</ng-container>

	<ng-container two-column-page-layout-right-content>
		<div class="lesson-support-info">
			<lb-notifications></lb-notifications>
			<lb-need-help-card></lb-need-help-card>
		</div>
	</ng-container>
</lb-two-column-page-layout>
